import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ProgressBarMode } from "@angular/material/progress-bar";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-progress-bar",
  templateUrl: "progress-bar.component.html",
  styleUrls: ["./progress-bar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressBarComponent {
  @Input() public mode: ProgressBarMode = "determinate";
  @Input() public value = null;
}
